<script setup lang="ts">
import type { NovaLayoutScrollContainerProps } from './NovaLayoutScrollContainer.types'
import { useAfterRender } from '@composables/useAfterRender'

const props = withDefaults(defineProps<NovaLayoutScrollContainerProps>(), {
  lockScrollContainer: false,
  isRerenderEndScrollToBottom: false,
})

const scrollContainerRef = ref<Nullable<HTMLElement>>(null)

const scrollToBottom = () => {
  if (scrollContainerRef.value) {
    scrollContainerRef.value.scrollTop = scrollContainerRef.value.scrollHeight
    console.log('요소가 업데이트되었고, 스크롤 이동 완료!')
  }
}

if (props.isRerenderEndScrollToBottom) {
  useAfterRender(scrollContainerRef, scrollToBottom)
}
</script>

<template>
  <div
    ref="scrollContainerRef"
    :class="['scroll-container', { 'lock-scroll': lockScrollContainer }]"
  >
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.scroll-container {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: overlay;
  width: 100%;
  height: 100%;
  @include transition(height 0.15s ease-in-out);

  &.lock-scroll {
    overflow-y: hidden;
  }
}
</style>
